import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Header from "../../components/Header";
import { BreadcrumbBox } from "../../components/common/Breadcrumb";
import Footer from "../../components/Footer";
import { Styles } from "./styles/course.js"; // reuse course styles
import { Constant, imageDomain } from "../../helper/Constants.js";
import axios from "axios";
import { Link } from "react-router-dom";
import PopularExams from "./components/PopularExams.js";

function ExamDetails() {
  const [exam, setExam] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [courseId, setCourseId] = useState(null)

  // helper: get id from URL (last segment)
  const getIdFromPath = () => {
    try {
      const parts = window.location.pathname.split("/").filter(Boolean);
      setCourseId(parts[parts.length - 1])
      return parts[parts.length - 1];
    } catch (e) {
      return null;
    }
  };

  // helper: build image url (uses imageDomain if available)
  const buildImageUrl = (img, fallback = "/assets/images/details-banner.jpg") => {
    if (!img) return process.env.PUBLIC_URL + fallback;
    if (/^https?:\/\//i.test(img)) return img;
    if (imageDomain)
      return imageDomain.replace(/\/$/, "") + (img.startsWith("/") ? "" : "/") + img;
    return (process.env.PUBLIC_URL || "") + (img.startsWith("/") ? img : "/" + img);
  };

  // helper: build file url (for docs / result)
  const buildFileUrl = (url) => {
    if (!url) return "#";
    if (/^https?:\/\//i.test(url)) return url;
    if (imageDomain)
      return imageDomain.replace(/\/$/, "") + (url.startsWith("/") ? "" : "/") + url;
    return (process.env.PUBLIC_URL || "") + (url.startsWith("/") ? url : "/" + url);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return null;
    const d = new Date(dateStr);
    if (Number.isNaN(d.getTime())) return null;
    return d.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  useEffect(() => {
    const getIdFromPath = () => {
      const parts = window.location.pathname.split("/").filter(Boolean);
      return parts[parts.length - 1];
    };
  
    setCourseId(getIdFromPath());
  }, [window.location.pathname]);

  useEffect(() => {
    const courseId = getIdFromPath();
    // if (!id) {
    //   setError("Exam id not found in URL.");
    //   setLoading(false);
    //   return;
    // }

    const fetchExam = async () => {
      setLoading(true);
      setError(null);
      try {
        // Build URL from Constants:
        // if you have something like Constant.getUrls.getAllExams = "/competitive-exams"
        // then details URL is "/competitive-exams/:id"
        

        const resp = await axios.get(Constant.getUrls.getAllExams + "/" + courseId);
        const payload = resp?.data?.data ?? resp?.data ?? null;
        const examData = payload?.data ?? payload ?? null;

        if (!examData) {
          setError("Exam data not found.");
          setExam(null);
        } else {
          setExam(examData);
        }
      } catch (err) {
        console.error("Failed to fetch exam:", err);
        setError(
          err?.response?.data?.message || err.message || "Failed to fetch exam"
        );
      } finally {
        setLoading(false);
      }
    };

    fetchExam();
  }, [courseId]);

  const title = exam?.exam_name || "Exam Details";
  const examDate = formatDate(exam?.exam_date);
  const examType = exam?.exam_type || "N/A";
  const venue = exam?.exam_venue || "N/A";
  const banner = exam?.exam_poster || "";
  const descriptionHTML = exam?.description || "";

  const docs = Array.isArray(exam?.exam_documents)
    ? exam.exam_documents
    : [];

  const examResult = exam?.exam_result || {};
  const resultUrl = examResult.result_url || "";
  const declaredOn = examResult.declared_on || null;
  const declaredOnFormatted = formatDate(declaredOn);

  // Decide result text
  let resultText = "";
  if (declaredOnFormatted) {
    const today = new Date();
    const d = new Date(declaredOn);
    if (!Number.isNaN(d.getTime()) && d <= today) {
      resultText = `Result declared on ${declaredOnFormatted}.`;
    } else if (!Number.isNaN(d.getTime())) {
      resultText = `Result will be declared on ${declaredOnFormatted}.`;
    } else {
      resultText = "Result date information is not available.";
    }
  } else if (resultUrl) {
    resultText = "Result is available for download.";
  } else {
    resultText = "Results will be announced shortly after the exam.";
  }

  return (
    <div className="main-wrapper course-details-page">
      {/* Header */}
      <Header />

      {/* Breadcrumb */}
      <BreadcrumbBox title="Exam Details" />

      <Styles>
        <section className="course-details-area">
          <Container>
            <Row>
              {/* Main column */}
              <Col lg="9" md="8" sm="12">
                <div className="course-details-top">
                  <div className="heading">
                    <h4>{title}</h4>
                  </div>

                  <div className="course-top-overview">
                    <div className="d-flex overviews">
                      <div className="category">
                        <h6>Exam Type</h6>
                        <p>{examType}</p>
                      </div>

                      <div className="rating">
                        <h6>Exam Date</h6>
                        <p>{examDate || "N/A"} </p>
                      </div>

                      <div className="rating px-3">
                        <h6>Venue</h6>
                        <p>{venue}</p>
                      </div>
                    </div>
                  </div>

                  <div className="course-details-banner">
                    <img
                      src={buildImageUrl(banner)}
                      alt={title}
                      className="img-fluid"
                      style={{ width: 600}}
                    />
                  </div>

                  {/* DESCRIPTION */}
                  <div className="course-desc">
                    <h5>Exam Description</h5>
                    {loading ? (
                      <p>Loading...</p>
                    ) : error ? (
                      <p style={{ color: "red" }}>{error}</p>
                    ) : (
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            descriptionHTML ||
                            "<p>No description provided.</p>",
                        }}
                      />
                    )}
                  </div>

                  {/* EXAM DOCUMENTS SECTION */}
                  <div className="course-desc" style={{ marginTop: 30 }}>
                    <h5>Exam Documents</h5>
                    {docs && docs.length > 0 ? (
                      <ul className="list-unstyled">
                        {docs.map((doc, index) => {
                          const docName =
                            doc.doc_name ||
                            `Document ${index + 1}`;
                          const docUrl = buildFileUrl(doc.doc_url);

                          return (
                            <li
                              key={index}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: 10,
                                borderBottom: "1px solid #eee",
                                paddingBottom: 8,
                              }}
                            >
                              <span>{docName}</span>
                              <div>
                                <a
                                  href={docUrl}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="btn btn-sm btn-outline-primary mr-2"
                                >
                                  View
                                </a>
                                <a
                                  href={docUrl}
                                  download
                                  className="btn btn-sm btn-primary"
                                >
                                  Download
                                </a>
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    ) : (
                      <p>No documents available for this exam.</p>
                    )}
                  </div>

                  {/* RESULT SECTION */}
                  <div className="course-desc" style={{ marginTop: 30 }}>
                    <h5>Results</h5>
                    <p>{resultText}</p>

                    {/* If resultUrl is present, show buttons */}
                    {resultUrl && (
                      <div style={{ marginTop: 10 }}>
                        <a
                          href={buildFileUrl(resultUrl)}
                          target="_blank"
                          rel="noreferrer"
                          className="btn btn-sm btn-outline-success mr-2"
                        >
                          View Result
                        </a>
                        <a
                          href={buildFileUrl(resultUrl)}
                          download
                          className="btn btn-sm btn-success"
                        >
                          Download Result
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              </Col>

              {/* Right column (you can keep PopularCourse, etc. or customize) */}
              <Col lg="3" md="4" sm="12">
                <div className="single-details-sidbar">
                  <Row>
                    {/* You can plug related exams or any widget here */}
                    <Col md="12">
                      <PopularExams />
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </Styles>

      <Footer />
    </div>
  );
}

export default ExamDetails;
